import React from 'react';
import {
    Box,
    Typography,
    Container
} from '@mui/material';
import './Dashboard.css';
const CommonDashboard = ({ data }) => {    
    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Welcome, {data.user.name}
                </Typography>                            
            </Box>
        </Container>
    );
};

export default CommonDashboard;
